/**
 * Color palette for Wholesaler, Partner, and Company pickers
 * Based on design specifications for light and dark modes
 */

export const PICKER_COLORS = {
    light: {
        wholesaler: {
            background: '#E6FAE9',
            border: '#D4F0D9',
            text: '#638C72',
            hoverBackground: '#D4F0D9',
            hoverBorder: '#C2E6C9',
            selectedBackground: '#C2E6C9',
            selectedBorder: '#B0DBB9',
            selectedHoverBackground: '#B0DBB9',
            selectedHoverBorder: '#A0D1AB',
        },
        partner: {
            background: '#F1F6FE',
            border: '#E2EDFF',
            text: '#3845A9',
            hoverBackground: '#E2EDFF',
            hoverBorder: '#D4E3FC',
            selectedBackground: '#D4E3FC',
            selectedBorder: '#C2D6F7',
            selectedHoverBackground: '#C2D6F7',
            selectedHoverBorder: '#B0C9F2',
        },
        company: {
            background: '#FFFFFF',
            border: '#F2F2F2',
            text: '#595959',
            hoverBackground: '#F9F9F9',
            hoverBorder: '#F2F2F2',
            selectedBackground: '#F5F5F5',
            selectedBorder: '#E0E0E0',
            selectedHoverBackground: '#EBEBEB',
            selectedHoverBorder: '#D9D9D9',
        },
    },
    dark: {
        wholesaler: {
            background: '#0A140E',
            border: '#1A2E21',
            text: '#4ADE80',
            hoverBackground: '#0D2116',
            hoverBorder: '#1B3D28',
            selectedBackground: '#142E1E',
            selectedBorder: '#4ADE80',
            selectedHoverBackground: '#1B3D28',
            selectedHoverBorder: '#4ADE80',
        },
        partner: {
            background: '#0A111F',
            border: '#1E293B',
            text: '#60A5FA',
            hoverBackground: '#111C33',
            hoverBorder: '#334155',
            selectedBackground: '#1E293B',
            selectedBorder: '#60A5FA',
            selectedHoverBackground: '#2A3A52',
            selectedHoverBorder: '#60A5FA',
        },
        company: {
            background: '#18181B',
            border: '#27272A',
            text: '#A1A1AA',
            hoverBackground: '#27272A',
            hoverBorder: '#3F3F46',
            selectedBackground: '#3F3F46',
            selectedBorder: '#52525B',
            selectedHoverBackground: '#52525B',
            selectedHoverBorder: '#52525B',
        },
    },
};

/**
 * Get colors for a specific entity type based on dark mode
 * @param {boolean} darkMode - Whether dark mode is enabled
 * @param {'wholesaler' | 'partner' | 'company'} entityType - The entity type
 * @returns {Object} Color palette for the entity
 */
export const getPickerColors = (darkMode, entityType) => {
    const mode = darkMode ? 'dark' : 'light';
    return PICKER_COLORS[mode][entityType];
};

/**
 * Modal background colors
 */
export const MODAL_COLORS = {
    light: {
        background: '#FFFFFF',
        headerBorder: '#E2E8F0',
        searchBackground: '#FFFFFF',
        searchBorder: '#E2E8F0',
    },
    dark: {
        background: '#1A202C',
        headerBorder: '#2D3748',
        searchBackground: '#2D3748',
        searchBorder: '#4A5568',
    },
};

export const getModalColors = (darkMode) => {
    return darkMode ? MODAL_COLORS.dark : MODAL_COLORS.light;
};
